import buildScenario from "./mockScenario";
import ScriptedTransportBase from "./scriptedTransportBase";

/**
 * In-memory transport that replays the scripted prospecting demo
 * (see mockScenario.js). Behind the sg_copilot_mock=1 flag only. All engine
 * mechanics live in ScriptedTransportBase; this only supplies the demo
 * scenario, its ctx, and the demo-mode fallback copy.
 */
class MockAgentTransport extends ScriptedTransportBase {
  constructor() {
    super({
      steps: buildScenario(),
      ctx: { salesforceConnected: false },
      fallbackText:
        "I'm running in demo mode right now, so I can only walk through the prospecting flow. Try asking for **companies in HR tech and SaaS with a funding round of $100M+**, point out a wrong title, or ask me to export to your CRM."
    });
  }
}

export default MockAgentTransport;
